enum ScheduledReportFrequencyEnum {
    DAILY = "daily",
    WEEKLY = "weekly",
    MONTHLY = "monthly",
}

export default ScheduledReportFrequencyEnum;
